module.exports = __webpack_public_path__ + "images/ce3e66a78c04a823668ca5e3c4f8284a-illu_dir_sign1.svg";